import axios from "axios";
import _ from "lodash";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../utils";

export default function useGetPlanningProdGridData(plan, unScheduled = false, refresh, dateRange, timeRange, overFlow = false) {
   const [data, setData] = useState({
      ScheduledData: [],
      UnScheduledData: [],
      PlanningIsLoading: false,
      TotalSpindlesUsed: "",
      TotalexpecBuildQty: "",
      TotalLaborHours: ""
   });

   useEffect(() => {
      if (!plan) return;

      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      try {
         const payload = { ...plan, ItemClass: "" };
         if (payload.DateFrom > payload.DateTo) {
            toast.error(`The from date must be prior to the end date`);
            return;
         }

         setData({
            ...data,
            PlanningIsLoading: true,
         });
         if (unScheduled) {
            api
               .postS(`Production/GetMachinePlanningInfoUnscheduled`, payload, source.token)
               .then((response) => {
                  if (response?.data?.success) {
                     setData({
                        UnScheduledData: response.data.gridData,
                        ScheduledData: [],
                        TotalSpindlesUsed: "",
                        TotalexpecBuildQty: "",
                        TotalLaborHours: ""
                     });
                     return;
                  } else {
                     setData({
                        ...data,
                        PlanningIsLoading: false,
                        TotalSpindlesUsed: "",
                        TotalexpecBuildQty: "",
                        TotalLaborHours: ""
                     });
                     return;
                  }
               })
               .catch(api.catchHandler);
         } else {
            // if(overFlow) {
            //     let str = payload.DateTo;
            //     let date = new Date(str); // Convert the string to a Date object
            //     date.setDate(date.getDate() - 1); // Subtract one day from the date

            //     // Adjust date back to the original format
            //     let adjustedDate = date.toISOString();
            //     payload.DateTo = adjustedDate;
            // }
            api
               .postS(`Production/GetMachinePlanningInfo`, payload, source.token)
               .then((response) => {
                  if (response?.data?.success) {
                     const dataResponse = response.data.gridData;
                     setData({
                        ScheduledData: dataResponse,
                        UnScheduledData: [],
                        TotalSpindlesUsed: _.sumBy(dataResponse, x => {
                           if (x.spindlesUsed) return x.spindlesUsed;
                        }),
                        TotalExpecBuildQty: _.sumBy(dataResponse, x => {
                           if (x.buildQty) return x.buildQty;
                        }),
                        TotalLaborHours: _.sumBy(dataResponse, x => {
                           if (x.laborHours) return x.laborHours;
                        })
                     });
                     return;
                  } else {
                     setData({
                        ...data,
                        PlanningIsLoading: false,
                     });
                     return;
                  }
               })
               .catch(api.catchHandler);
         }
      } catch (error) {
         toast.error(error);
         setData({ ...data, PlanningIsLoading: false });
      }

      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [dateRange, plan, refresh, unScheduled, timeRange]);

   return data;
}
